import {useTranslation} from "react-i18next";
import {type ChangeEvent, useState} from "react";
import {Button, Modal} from "react-bootstrap";
import DaumPostcode from "react-daum-postcode";
import Job from "./Job.tsx";
import {Field} from "./Field.tsx";

interface PostcodeData {
    address: string;
    bname?: string;
    zonecode: string;
}

interface OptionalInfoProps {
    jobData: string
}

const OptionalInfo = ({jobData}: OptionalInfoProps) => {
    const {t} = useTranslation('ui');

    const [data, setData] = useState<{
        address: string,
        detailAddress: string,
        isModalOpen: boolean
    }>({
        address: "",
        detailAddress: "",
        isModalOpen: false
    });

    const handlePostcodeComplete = (data: PostcodeData) => {
        const fullAddress = data.address;
        const extraAddress = data.bname ? `(${data.bname})` : '';
        setData((prev) => ({
            ...prev,
            address: fullAddress + extraAddress,
            isModalOpen: false
        }))
    };

    const handleDetailAddrChange = (e: ChangeEvent<HTMLInputElement>) => {
        setData((prev) => ({
            ...prev,
            detailAddress: e.target.value
        }))
    };

    function onCloseModal() {
        setData((prev) => ({
            ...prev,
            isModalOpen: false
        }));
    }

    return (
        <>
            <div className="col">
                <div className="card rounded-4 p-4">
                    <h5 className="pb-1 subheadings">{t("signUp.OptionalDetails")}</h5>

                    <Field name="birthday" label={t("signUp.birthdayLabel")} type="date"/>

                    <Field name="sign_up_path" label={t("signUp.signUpPathLabel")}
                           placeholder={t("signUp.signUpPathPlaceholder")}
                           noErrorChange/>

                    <Job jobData={jobData}/>

                    <Field name="office" label={t("signUp.officeLabel")}
                           placeholder={t("signUp.officePlaceholder")}
                           noErrorChange/>

                    <div className="signup_container">
                        <label htmlFor="addr">{t("signUp.addressLabel")}</label>
                        <div className="d-flex align-content-center">
                            <input type="text"
                                   value={data.address}
                                   name="addr"
                                   readOnly
                                   required
                                   className="form-control custom-input"
                                   placeholder={t("signUp.addressPlaceholder")}/>
                            <button type="button"
                                    className="btn btn-skyblue rounded-4 ms-2"
                                    onClick={() => {
                                        setData((prev) => ({
                                            ...prev,
                                            isModalOpen: true
                                        }))
                                    }}
                                    style={{whiteSpace: "nowrap", fontSize: "16px"}}>{t("signUp.findAddress")}
                            </button>
                        </div>
                        {data.address && (
                            <>
                                <div></div>
                                <div>
                                    <input
                                        type="text"
                                        name="addr_detail"
                                        className="form-control custom-input mt-2"
                                        value={data.detailAddress}
                                        onChange={handleDetailAddrChange}
                                        placeholder={t("signUp.detailAddressPlaceholder")}
                                    />
                                </div>
                            </>
                        )}
                    </div>
                </div>
            </div>
            <div>
                <Modal show={data.isModalOpen} onHide={onCloseModal} contentClassName="rounded-4 border-0">
                    <Modal.Header>
                        <Modal.Title><h6 className="text-primary pt-2">{t("signUp.findAddress")}</h6></Modal.Title>
                        <Button variant="white" className="btn_close" onClick={onCloseModal}>X
                        </Button>
                    </Modal.Header>
                    <Modal.Body>
                        <DaumPostcode
                            onComplete={handlePostcodeComplete}
                            autoClose
                            style={{width: '100%', height: '400px'}}
                        />
                    </Modal.Body>
                </Modal>
            </div>
        </>
    )
}

export default OptionalInfo;